import { Slot } from '@radix-ui/react-slot'
import { assumeNonNull } from '@repo/studio-utils/utils/null-check'
import * as React from 'react'
import { tw } from 'utils/classnames'

export const PopoverComponentsScrollable = function Root({
  ref,
  children,
  asChild,
  ...props
}: React.ComponentProps<'div'> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : 'div'

  return (
    <>
      {/* 1st component is to allow the hitbox/psuedo elements */}
      <Comp data-popover-parent className="relative">
        {/* 2nd element is the actual popover */}
        <div
          data-popover-parent-child
          className="bg-gray-1000 rounded-4 relative h-full overflow-hidden shadow-md border border-gray-800"
        >
          {/* 3rd element is where the scrolling can start */}
          <div
            {...props}
            ref={ref}
            data-popover-parent-child-child
            style={{
              '--scroller-gutter': '10px',
            }}
            className={tw(
              'scroller-xs max-h-[calc(var(--radix-popper-available-height)_-_1.25rem)] py-[10px]',
              props.className,
            )}
          >
            {children}
          </div>
        </div>
      </Comp>
    </>
  )
}

export const PopoverComponentsFilters = function Filters({
  ref,
  children,
  ...props
}: React.ComponentProps<'div'> & {
  ref?: React.RefObject<HTMLDivElement>
}) {
  const innerRef = React.useRef<HTMLDivElement>(null)

  React.useImperativeHandle(ref, () => assumeNonNull(innerRef.current))

  return (
    <div
      data-popover-filters
      className="rounded-4 bg-gray-1000 shadow-3-smooth relative overflow-hidden border border-gray-800"
    >
      <div
        data-popover-filters-child
        ref={innerRef}
        {...props}
        style={{
          ...props.style,
          '--scroller-gutter': '16px',
        }}
        className={tw(
          'scroller scroller-xs h-full max-h-[calc(var(--radix-popper-available-height)_-_1.25rem)] overflow-y-scroll py-[16px]',
          props.className,
        )}
      >
        {children}
      </div>
    </div>
  )
}

export const PopoverComponentsItems = function Items({
  ref,
  ...props
}: React.ComponentProps<'div'> & {
  ref?: React.RefObject<HTMLDivElement>
}) {
  const innerRef = React.useRef<HTMLDivElement>(null)

  React.useImperativeHandle(ref, () => assumeNonNull(innerRef.current))

  return (
    <div
      {...props}
      ref={innerRef}
      data-popover-container
      className={tw('rounded-2 flex flex-col bg-gray-800 p-2', props.className)}
    />
  )
}
